module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI4LjM1IDkuMjUzMTVMMjYuNzQ2OSA3LjY1MDAyTDE4IDE2LjQyNUw5LjI1MzE1IDcuNjUwMDJMNy42NTAwMiA5LjI1MzE1TDE2LjQyNSAxOEw3LjY1MDAyIDI2Ljc0NjlMOS4yNTMxNSAyOC4zNUwxOCAxOS42MDMxTDI2Ljc0NjkgMjguMzVMMjguMzUgMjYuNzQ2OUwxOS42MDMxIDE4TDI4LjM1IDkuMjUzMTVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newhome/closew.svg
// module id = 6yDe
// module chunks = 0